'use strict';

angular.module('theme').service('CustomerService', function ($q, $http, $window, $cookies, $rootScope, TrackerService) {

	var self = this;

	function updateGlobalInstance(customer) {
		$rootScope.customer = customer;

		TrackerService.customerEvent(customer);

		self._setCategoryCookie(customer);
	}

	var getRequestCache;

	/**
	 * Will get the current logged in customer
	 * @return customer
	 */
	this.get = function () {
		if (getRequestCache) {
			return getRequestCache;
		}

		getRequestCache = $http({
			url: '/backapi/customer',
			method: 'GET',
			cache: false
		}).then(function (response) {
			getRequestCache = undefined;

			var customer = response.data;
			customer.hasAccessToMyPage = customer.category === 'active-subscription' || customer.category === 'active' || customer.category === 'special' || customer.category === 'paused' || customer.category === 'test';

			updateGlobalInstance(customer);

			return customer;
		}, function(error) {

			// Remove login token if account no longer is valid and redirect to login page
			if (error.status === 401) {

				$cookies.remove('token', {
					path: '/'
				});

				$cookies.remove('cart-token', {
					path: '/'
				});

				$cookies.remove('cart', true, {
					path: '/'
				});

				$window.location.href = '/login?no-account=true';
			}
		});

		return getRequestCache;
	};

	// alias that shows pure intent
	this.update = this.get;

	// Allow us to fire an event that updates the customer;
	$rootScope.$on('customer:update', this.get);

	this.save = function (customer) {
		return $http({
			url: '/backapi/customer',
			method: 'POST',
			data: customer
		}).then(function (response) {
			updateGlobalInstance(customer);

			response.data.returnStatus = response.status;

			return response.data;
		});
	};

	this.saveSSN = function (socialSecurityNumber) {
		return $http({
			url: '/backapi/customer',
			method: 'POST',
			data: {
				socialSecurityNumber: socialSecurityNumber
			}
		}).then(function (response) {
			updateGlobalInstance(response.data);

			return response.data;
		});
	};

	this.saveAddressLookup = function (uc) {

		// Since the names are one field, we split by space and take the last item as the lastName,
		// and then everything else is the firstName
		var names = uc.name.split(' ');
		var lastName = names.pop();
		var firstname = names.join(' ');

		return $http({
			url: '/backapi/customer',
			method: 'POST',
			data: {
				socialSecurityNumber: uc.socialSecurityNumber,
				firstName: firstname,
				lastName: lastName,
				billingAddress: {
					address: uc.address,
					zipCode: uc.zipcode,
					city: uc.city
				}
			}
		}).then(function (response) {
			updateGlobalInstance(response.data);

			return response.data;
		});
	};

	this.saveDeliveryInformation = function (deliveryInformation) {
		return $http({
			url: '/backapi/customer',
			method: 'POST',
			data: {
				firstName: deliveryInformation.firstName,
				lastName: deliveryInformation.lastName,
				mobile: deliveryInformation.mobile,
				shippingAddress: {
					address: deliveryInformation.shippingAddress.address,
					zipCode: deliveryInformation.shippingAddress.zipCode,
					city: deliveryInformation.shippingAddress.city,
					doorcode: deliveryInformation.shippingAddress.doorcode,
					floor: deliveryInformation.shippingAddress.floor,
					message: deliveryInformation.shippingAddress.message
				},
				billingAddress: {
					address: deliveryInformation.shippingAddress.address,
					zipCode: deliveryInformation.shippingAddress.zipCode,
					city: deliveryInformation.shippingAddress.city,
				}
			}
		}).then(function (response) {
			updateGlobalInstance(response.data);

			return response.data;
		});
	};

	this.saveShippingAddress = function (address) {
		return $http({
			url: '/backapi/customer',
			method: 'POST',
			data: {
				shippingAddress: {
					address: address.address,
					zipCode: address.zipCode,
					city: address.city
				}
			}
		}).then(function (response) {
			updateGlobalInstance(response.data);

			return response.data;
		});
	};

	this.saveDetails = function (mobile, doorcode, floor, message) {
		return $http({
			url: '/backapi/customer',
			method: 'POST',
			data: {
				mobile: mobile,
				shippingAddress: {
					doorcode: doorcode,
					floor: floor,
					message: message
				}
			}
		}).then(function (response) {
			updateGlobalInstance(response.data);

			return response.data;
		});
	};

	this.resetPassword = function(email) {
		return $http({
			url: '/login/reset-password',
			method: 'POST',
			data: {
				email: email
			}
		}).then(function (response) {
			return response.data;
		});
	};

	this.setPassword = function(oldPassword, newPassword) {
		var oldPasswordMD5 = md5(oldPassword);
		var newPasswordMD5 = md5(newPassword);

		return $http({
			url: '/backapi/customer/newpassword',
			method: 'POST',
			data: {
				oldPasswordMD5: oldPasswordMD5,
				newPasswordMD5: newPasswordMD5
			}
		}).then(function (response) {
			return response.data;
		});
	};

	this.prospectToCustomer = function(data) {
		return $http({
			url: '/backapi/prospect-customer',
			method: 'POST',
			data: data
		}).then(function (response) {
			return response.data;
		});
	};

	this.agreeTerms = function () {
		return $http({
			url: '/backapi/customer',
			method: 'POST',
			data: {
				agreed: true
			}
		}).then(function (response) {
			var customer = response.data;
			customer.hasAccessToMyPage = customer.category === 'active-subscription' || customer.category === 'active' || customer.category === 'special' || customer.category === 'paused' || customer.category === 'test';

			updateGlobalInstance(customer);

			return response.data;
		});
	};

	this.createCustomer = function(email) {
		return $http({
			url: '/backapi/customer',
			method: 'POST',
			data: {
				email: email,
				checkEmail: true
			}
		}).then(function (response) {
			return response.data;
		});
	};

	this.createTempCustomer = function(email) {
		return $http({
			url: '/backapi/customer',
			method: 'POST',
			data: {
				email: email,
				checkEmail: false
			}
		}).then(function (response) {
			return response.data;
		});
	};

	this.getCategoryCookie = function () {
		return $cookies.get('category');
	};

	this._setCategoryCookie = function (customer) {
		if (!customer) {
			return;
		}

		var expires = new Date();
		expires.setDate(expires.getDate() + 365);

		$cookies.put('category', customer.category, {
			path: '/',
			expires: expires
		});
	};
});
